import { useMemo } from "react"
import { Switch } from "react-router-dom"
import { compose, withHooks, withStores } from "enhancers"
import { safe } from "common/helper"

const enhancer = compose(
  withStores((stores: any) => ({
    currentRole: stores.appStore.currentRole,
  })),
  withHooks((props: any) => {
    const children = useMemo(() => {
      if (props.children) {
        return props.children.filter((child: any, index: number) => {
          const permittedRoles = safe(() => child.props.permittedRoles, null)

          if (permittedRoles) {
            const authorized = permittedRoles.includes(props.currentRole)
            return authorized
          }

          return true
        })
      }
    }, [props.children, props.currentRole])

    return {
      ...props,
      children,
    }
  }),
)

export default enhancer(Switch)
